import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";

/**
 * Sticky banner shown on /app/* when a super_admin is impersonating an owner.
 * Provides a one-click "Exit impersonation → back to /admin" button.
 */
export default function ImpersonationBanner() {
  const { user, checkAuth } = useAuth();
  const nav = useNavigate();
  if (!user?.is_impersonating || user.role !== "super_admin") return null;

  const exit = async () => {
    try { await api.post("/admin/impersonate/stop"); } catch (e) { console.warn("impersonate/stop failed, navigating away anyway:", e); }
    await checkAuth();
    nav("/admin");
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="flex items-center justify-between gap-3 px-4 py-2 border-b"
      style={{
        background: "linear-gradient(90deg, rgba(255,220,80,0.15), rgba(255,220,80,0.02))",
        borderColor: "#ffd452",
        position: "sticky", top: 0, zIndex: 40,
      }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <ShieldCheck size={14} style={{ color: "#ffd452", flexShrink: 0 }} />
        <span className="label-tiny truncate" style={{ color: "#ffd452" }}>
          Impersonating <b className="mono">{user.academy_id}</b> · every action is logged.
        </span>
      </div>
      <button
        onClick={exit}
        className="btn btn-outline shrink-0"
        style={{ borderColor: "#ffd452", color: "#ffd452", padding: "4px 10px" }}
        data-testid="btn-exit-impersonation"
      >
        <LogOut size={12} /> Exit
      </button>
    </div>
  );
}
